
import React, { Suspense, useState, useEffect } from "react";
import { CommonUtilities } from '../../commonUtils';
import Modal from 'react-responsive-modal';
import { ContractWizardInfo } from "./ContractWizardInfo";
import globalSearchService from "../commonSearch/globalSearchServices";
import { ContractWizardSummary } from "./ContractWizardSummary";
import { ContractWizardRoyalties } from "./ContractWizardRoyalties";
import { ContractWizardAdjustment } from "./ContractWizardAdjustment";
import { ContractWizardReserves } from "./ContractWizardReserves";
import { ContractWizardRates } from "./ContractWizardRates";
import { ContractWizardRegion } from "./ContractWizardRegion";
import { ContractWizardDate } from "./ContractWizardDate";
import { ContractWizardStatus } from "./ContractWizardstatus";
import ContactWizardInfo from "./ContactWizardInfo";
import ContactAddressDetail from "./ContactAddressDetail";
import ContactWizardDetail from "./ContactWizardDetail";
import ContactWizardStatus from "./ContactWizardStatus";
import ContactWizardRecipients from "./ContactWizardRecipients";
import ContactWizardSocieties from "./ContactWizardSocieties";

export default function MainWizard(MainWizard: any) {

    console.log(MainWizard)

    var leftPanel = [
        {
            Type: 'Contract',
            title: 'General Info'
        }, {
            Type: 'Contract',
            title: 'Status'
        }, {
            Type: 'Contract',
            title: 'Dates'
        }, {
            Type: 'Contract',
            title: 'Region'
        }, {
            Type: 'Contract',
            title: 'Rates'
        }, {
            Type: 'Contract',
            title: 'Reserves'
        }, {
            Type: 'Contract',
            title: 'Adjustments'
        }, {
            Type: 'Contract',
            title: 'Reducing Royalties'
        }, {
            Type: 'Contract',
            title: 'Summary'
        },


        {
            Type: 'Contact',
            title: 'Required Information'
        }, {
            Type: 'Contact',
            title: 'Address Details'
        }, {
            Type: 'Contact',
            title: 'Contact Details'
        }, {
            Type: 'Contact',
            title: 'Statuses'
        }, {
            Type: 'Contact',
            title: 'Recipients'
        }, {
            Type: 'Contact',
            title: 'Societies'
        }
    ]

    const [activeTab, setactiveTab] = useState('');

    const closeWizard = () => {

        MainWizard.MainWizardClose();
    }

    useEffect(() => {

        if (activeTab.length === 0) {
            const contractItem = leftPanel.find(item => item.Type === MainWizard.type);
            const title = contractItem ? contractItem.title : '';
            console.log(title)
            setactiveTab(title)
        }

    }, []);


    const onSave = (e: any) => {
        console.log(e);

        if (!MainWizard.code) {
            MainWizard.onSaveUpdate(e)
        }
    }
    var indexFull = 0;
    return (
        <div>
            <Modal open={MainWizard.openMainWizard} onClose={() => closeWizard()} styles={{ modalContainer: { background: 'transparent !important', height: "50% !important" } }} center classNames={{ overlay: '', modal: 'ws-12 paddingCenterBox pull-right bgTransparent allowHscroll allowVscroll' }} >


                <div className="wizard-container allowHscroll allowVscroll">

                    <div className="w-18 pl ptl pbl wizardNavigation" >
                        <div className="wizardForm pLarge">

                            {
                                leftPanel.map((value, index) => {
                                    if (value.Type === MainWizard.type) {
                                        return (
                                            <div onClick={() => setactiveTab(value.title)} className="pLarge ws-12" >

                                                <div className="ws-3">


                                                    <button className={activeTab === value.title ? "roundedButtons noBorder paleblue" : "roundedButtons noBorder"} style={{ width: "20px", height: "20px" }}>
                                                        <span className="mr"> {indexFull += 1} </span>
                                                    </button>
                                                </div>

                                                <div className="ws-8">
                                                    <span className={activeTab === value.title ? " zFront white" : " zFront grey"}> {value.title}</span>
                                                </div>
                                            </div>
                                        )
                                    }
                                })
                            }

                        </div>

                    </div>

                    <div className="w-82 p0 landing wizard-content" >

                        <>
                            {(() => {
                                if (activeTab === 'General Info' && MainWizard.type === "Contract") {
                                    return <ContractWizardInfo data={MainWizard} />
                                }

                                if (activeTab === 'Status' && MainWizard.type === "Contract") {
                                    return <ContractWizardStatus data={MainWizard} />
                                }

                                if (activeTab === 'Dates' && MainWizard.type === "Contract") {
                                    return <ContractWizardDate data={MainWizard} />
                                }

                                if (activeTab === 'Region' && MainWizard.type === "Contract") {
                                    return <ContractWizardRegion data={MainWizard} />
                                }

                                if (activeTab === 'Rates' && MainWizard.type === "Contract") {
                                    return <ContractWizardRates data={MainWizard} />
                                }

                                if (activeTab === 'Reserves' && MainWizard.type === "Contract") {
                                    return <ContractWizardReserves data={MainWizard} />
                                }

                                if (activeTab === 'Adjustments' && MainWizard.type === "Contract") {
                                    return <ContractWizardAdjustment data={MainWizard} />
                                }

                                if (activeTab === 'Reducing Royalties' && MainWizard.type === "Contract") {
                                    return <ContractWizardRoyalties data={MainWizard} />
                                }

                                if (activeTab === 'Summary' && MainWizard.type === "Contract") {
                                    return <ContractWizardSummary data={MainWizard} />
                                }




                                if (activeTab === 'Required Information' && MainWizard.type === "Contact") {
                                    return <ContactWizardInfo data={MainWizard} onSave={onSave} />
                                }

                                if (activeTab === 'Address Details' && MainWizard.type === "Contact") {
                                    return <ContactAddressDetail data={MainWizard} />
                                }

                                if (activeTab === 'Contact Details' && MainWizard.type === "Contact") {
                                    return <ContactWizardDetail data={MainWizard} />
                                }

                                if (activeTab === 'Statuses' && MainWizard.type === "Contact") {
                                    return <ContactWizardStatus data={MainWizard} />
                                }

                                if (activeTab === 'Recipients' && MainWizard.type === "Contact") {
                                    return <ContactWizardRecipients data={MainWizard} />
                                }

                                if (activeTab === 'Societies' && MainWizard.type === "Contact") {
                                    return <ContactWizardSocieties data={MainWizard} />
                                }

                            })()}
                        </>

                        <div className="ws-12 pls prs pbl pr mtl">

                            <div className="box ws-12">
                                <div className="box-footer">
                                    <a className="icon-btn edit pull-right width100 height35">NEXT</a>
                                    <a className="icon-btn edit pull-right mr hide width100 height35">BACK</a>

                                    <a className="icon-btn delete pull-right mr width100 height35" onClick={() => closeWizard()}> Close</a>

                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </Modal >

        </div>

    )

}